// import React, { useEffect, useCallback } from "react";
// import {
//   useDesignFormStore,
//   SizeSegment,
//   CostingBreakdown,
//   FabricUsageRow,
// } from "../../store/DesignMasterStore";

// const calculateCategoryTotal = (
//   rows: FabricUsageRow[],
//   sizeId: string
// ): number =>
//   rows.reduce((acc, row) => acc + (parseFloat(row.values[sizeId]) || 0), 0);

// const OverallCostingTab: React.FC = () => {
//   const {
//     fabricSpecs,
//     astar,
//     dupatta,
//     additionalFabric,
//     fabricUsage,
//     overallCosting,
//     updateCostingBreakdown,
//     updateOverallCostingNotes,
//   } = useDesignFormStore();

//   console.log("OverallCostingTab", overallCosting);

//   const { sizeSegments } = fabricUsage;
//   const { breakdown, costingNotes } = overallCosting;

//   const fabricPannaRate = parseFloat(fabricSpecs.pannaRate) || 0;
//   const astarPannaRate = parseFloat(astar.pannaRate) || 0;
//   const dupattaPannaRate = parseFloat(dupatta.pannaRate) || 0;
//   const additionalFabricPannaRate = parseFloat(additionalFabric.pannaRate) || 0;

//   // --- Main Calculation ---
//   const runCalculations = useCallback(() => {
//     const newBreakdown: CostingBreakdown = {};

//     if (!sizeSegments || sizeSegments.length === 0) {
//       updateCostingBreakdown({});
//       return;
//     }

//     sizeSegments.forEach((segment) => {
//       const sizeId = segment.id;

//       // Category totals meters
//       const fabricComponentsTotal =
//         calculateCategoryTotal(fabricUsage.fabricComponents.rows, sizeId) || 0;
//       const designWorkTotal =
//         calculateCategoryTotal(fabricUsage.designWork.rows, sizeId) || 0;
//       const astarTotal =
//         calculateCategoryTotal(fabricUsage.astar.rows, sizeId) || 0;
//       const dupattaTotal =
//         calculateCategoryTotal(fabricUsage.dupatta.rows, sizeId) || 0;
//       const additionalComponentUsage = calculateCategoryTotal(
//         fabricUsage.additionalComponent.rows,
//         sizeId
//       );

//       // Category totals rates

//       const handWorkTotal =
//         calculateCategoryTotal(fabricUsage.handwork.rows, sizeId) || 0;
//       const embroideryTotal =
//         calculateCategoryTotal(fabricUsage.embroidery.rows, sizeId) || 0;
//       const stitchingTotal =
//         calculateCategoryTotal(fabricUsage.stitching.rows, sizeId) || 0;
//       const accessoriesTotal =
//         calculateCategoryTotal(fabricUsage.accessories.rows, sizeId) || 0;

//       const additionalComponentTotal =
//         calculateCategoryTotal(fabricUsage.additionalComponent.rows, sizeId) ||
//         0;
//       const rateTableTotal =
//         calculateCategoryTotal(fabricUsage.rate.rows, sizeId) || 0;

//       const totalMaterialCost =
//         fabricComponentsTotal * fabricPannaRate +
//         designWorkTotal * fabricPannaRate +
//         astarTotal * astarPannaRate +
//         dupattaTotal * dupattaPannaRate +
//         additionalComponentUsage * additionalFabricPannaRate;

//       const totalDirectRates =
//         handWorkTotal +
//         embroideryTotal +
//         stitchingTotal +
//         accessoriesTotal +
//         additionalComponentTotal +
//         rateTableTotal;

//       const finalPrice = totalMaterialCost + totalDirectRates;

//       // const combinedUsageTotal = fabricComponentsTotal + designWorkTotal + handWorkTotal + embroideryTotal + stitchingTotal +accessoriesTotal + additionalComponentTotal        ;
//       // const materialCost = combinedUsageTotal * pannaRate;
//       // const finalPrice = materialCost + rateTableTotal ;

//       //  Safe defaults for every size
//       newBreakdown[sizeId] = {
//         fabricComponentsTotal,
//         designWorkTotal,
//         astarTotal: astarTotal,
//         dupattaTotal: dupattaTotal,
//         additionalComponent: additionalComponentUsage,
//         materialCost: totalMaterialCost,
//         handWorkTotal,
//         embroideryTotal,
//         stitchingTotal,
//         accessoriesTotal,
//         rateTableTotal,
//         additionalComponentTotal,
//         directRatesTotal: totalDirectRates,
//         finalPrice,
//       };
//     });

//     updateCostingBreakdown(newBreakdown);
//   }, [
//     fabricUsage,
//     fabricPannaRate,
//     astarPannaRate,
//     dupattaPannaRate,
//     additionalFabricPannaRate,
//     sizeSegments,
//     updateCostingBreakdown,
//   ]);

//   // Run calculations whenever dependency changes
//   useEffect(() => {
//     runCalculations();
//   }, [runCalculations]);

//   // Ensure initial zero breakdown if sizes exist but no data yet
//   useEffect(() => {
//     if (sizeSegments.length > 0 && Object.keys(breakdown).length === 0) {
//       runCalculations();
//     }
//   }, [sizeSegments, breakdown, runCalculations]);

//   // --- UI ---
//   return (
//     <div className="space-y-8">
//       {/* Header */}
//       <div>
//         <h2 className="text-2xl font-bold text-gray-900 mb-2">
//           Overall Costing
//         </h2>
//         <p className="text-gray-500">
//           Comprehensive pricing calculation for each size based on fabric usage
//           and rates.
//         </p>
//       </div>

//       {/* Panna Rate */}
//       {/* <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
//         <label className="block text-sm font-medium text-gray-700">
//           Panna Rate (from Fabric Specs)
//         </label>
//         <input
//           type="number"
//           readOnly
//           value={pannaRate.toFixed(2)}
//           className="text-2xl font-bold text-blue-800 bg-transparent w-full focus:outline-none"
//         />
//         <p className="text-xs text-blue-700 mt-1">
//           This rate will be multiplied with total usage for each size.
//         </p>
//       </div> */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//         <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
//           <label className="text-sm font-medium text-gray-700">
//             Fabric Rate
//           </label>
//           <p className="text-xl font-bold text-blue-800">
//             ₹{fabricPannaRate.toFixed(2)}
//           </p>
//         </div>

//         <div className="bg-purple-50 border border-purple-200 p-4 rounded-lg">
//           <label className="text-sm font-medium text-gray-700">
//             Astar Rate
//           </label>
//           <p className="text-xl font-bold text-purple-800">
//             ₹{astarPannaRate.toFixed(2)}
//           </p>
//         </div>

//         <div className="bg-pink-50 border border-pink-200 p-4 rounded-lg">
//           <label className="text-sm font-medium text-gray-700">
//             Dupatta Rate
//           </label>
//           <p className="text-xl font-bold text-pink-800">
//             ₹{dupattaPannaRate.toFixed(2)}
//           </p>
//         </div>

//         <div className="bg-gray-50 border border-gray-200 p-4 rounded-lg">
//           <label className="text-sm font-medium text-gray-700">
//             Add. Fabric Rate
//           </label>
//           <p className="text-xl font-bold text-gray-800">
//             ₹{additionalFabricPannaRate.toFixed(2)}
//           </p>
//         </div>
//       </div>

//       {/* Cost Breakdown Table */}
//       <div className="bg-white rounded-lg shadow-sm border border-gray-400 overflow-x-auto">
//         <h3 className="text-xl font-bold text-gray-800 px-6 py-4">
//           Cost Breakdown by Size
//         </h3>
//         <table className="w-full text-sm">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="p-3 text-left border">Cost Component</th>
//               {sizeSegments.map((s) => (
//                 <th key={s.id} className="p-3 text-center border">
//                   {s.name}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>

//             {/*  meters section */}
//             <tr>
//               <td className="p-3 border">Fabric Components Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.fabricComponentsTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>
//             <tr>
//               <td className="p-3 border">Design Work Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.designWorkTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>

//             <tr>
//               <td className="p-3 border">Astar Usage</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.astarTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>
//             <tr>
//               <td className="p-3 border">Dupatta Usage</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.dupattaTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>

//             <tr>
//               <td className="p-3 border">Additional Component </td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.additionalComponentTotal?.toFixed(2) ??
//                     "0.00"}
//                 </td>
//               ))}
//             </tr>

//             {/*  RATES  SECTION */}

//             <tr>
//               <td className="p-3 border">Handwork Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.handWorkTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>
//             <tr>
//               <td className="p-3 border">Embroidery Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.embroideryTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>
//             <tr>
//               <td className="p-3 border">Stitching Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.stitchingTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>
//             <tr>
//               <td className="p-3 border">Accessories Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.accessoriesTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>

//             <tr>
//               <td className="p-3 border">Rate Table Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.rateTableTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>

//             <tr>
//               <td className="p-3 border">Additional Component Total</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.additionalComponentTotal?.toFixed(2) ??
//                     "0.00"}
//                 </td>
//               ))}
//             </tr>

//             <tr className="bg-green-50 font-semibold text-green-800">
//               <td className="p-3 border">Total Material Cost</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   {breakdown[s.id]?.materialCost?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>

//             <tr className="bg-yellow-50 font-semibold text-yellow-800">
//               <td className="p-3 border">Total Direct Rates Cost</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border">
//                   ₹{breakdown[s.id]?.directRatesTotal?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>

//           </tbody>
//           <tfoot>
//             <tr className="bg-orange-100 font-bold text-orange-800">
//               <td className="p-3 border">Final Pricing per Size</td>
//               {sizeSegments.map((s) => (
//                 <td key={s.id} className="p-3 text-right border text-lg">
//                   ₹{breakdown[s.id]?.finalPrice?.toFixed(2) ?? "0.00"}
//                 </td>
//               ))}
//             </tr>
//           </tfoot>
//         </table>
//       </div>

//       <div>
//         <label
//           htmlFor="costingNotes"
//           className="block text-sm font-medium text-gray-700 mb-1"
//         >
//           Costing Notes & Remarks
//         </label>
//         <textarea
//           id="costingNotes"
//           rows={4}
//           value={costingNotes}
//           onChange={(e) => updateOverallCostingNotes(e.target.value)}
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//           placeholder="Add any additional notes about pricing, discounts, or special considerations..."
//         />
//       </div>
//     </div>
//   );
// };

// export default OverallCostingTab;




import React, { useEffect, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import {
  useDesignFormStore,
  CostingBreakdown,
  FabricUsageRow,
  SizeSegment,
} from "../../store/DesignMasterStore";
import axiosApi from "../../server/service";
import { ChevronDown } from "lucide-react";

const calculateCategoryTotal = (
  rows: FabricUsageRow[],
  sizeId: string
): number =>
  rows.reduce((acc, row) => acc + (parseFloat(row.values[sizeId]) || 0), 0);

const OverallCostingTab: React.FC = () => {
  const { designId } = useParams();
  const {
    fabricSpecs,
    astar,
    dupatta,
    additionalFabric,
    fabricUsage,
    overallCosting,
    updateCostingBreakdown,
    updateOverallCostingNotes,
  } = useDesignFormStore();

  const { sizeSegments } = fabricUsage;
  const { breakdown, costingNotes } = overallCosting;

  // State for size segment filtering
  const [allAvailableSegments, setAllAvailableSegments] = useState<
    SizeSegment[]
  >([]);
  const [selectedSegmentIds, setSelectedSegmentIds] = useState<Set<string>>(
    new Set()
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  const fabricPannaRate = parseFloat(fabricSpecs.pannaRate) || 0;
  const astarPannaRate = parseFloat(astar.pannaRate) || 0;
  const dupattaPannaRate = parseFloat(dupatta.pannaRate) || 0;
  const additionalFabricPannaRate = parseFloat(additionalFabric.pannaRate) || 0;

  // Fetch all available size segments with design usage info
  const fetchAllSizeSegments = useCallback(async () => {
    try {
      let activeSegments: SizeSegment[] = [];
      let segmentsToSelect: string[] = [];

      if (designId) {
        // Use the new API that includes isBeingUsedForThisDesign flag
        const res = await axiosApi.get<{
          message: string;
          data: Array<{
            _id: string;
            segmentName: string;
            status: string;
            numberOfSets: number;
            isBeingUsedForThisDesign: boolean;
          }>;
        }>(`/api/sizeSegment/get-segments-with-design-usage/${designId}`);
        
        activeSegments = res.data.data
          .filter((s) => s.status === "Active")
          .map((s) => ({
            id: s._id,
            name: s.segmentName,
          }));
        
        // Select segments where isBeingUsedForThisDesign is true
        segmentsToSelect = res.data.data
          .filter((s) => s.status === "Active" && s.isBeingUsedForThisDesign)
          .map((s) => s._id);
      } else {
        // For new designs, use the regular API
        const res = await axiosApi.get<
          Array<{
            _id: string;
            segmentName: string;
            status: string;
            numberOfSets: number;
          }>
        >("/api/sizeSegment/get-all-segments");
        
        activeSegments = res.data
          .filter((s) => s.status === "Active")
          .map((s) => ({
            id: s._id,
            name: s.segmentName,
          }));
        
        // For new designs, select all active segments
        segmentsToSelect = activeSegments.map((s) => s.id);
      }

      setAllAvailableSegments(activeSegments);
      // Initialize with segments to select
      setSelectedSegmentIds((prev) => {
        if (prev.size === 0 && segmentsToSelect.length > 0) {
          return new Set(segmentsToSelect);
        }
        return prev;
      });
    } catch (err) {
      console.error("Failed to fetch size segments:", err);
    }
  }, [designId]);

  // Toggle segment selection
  const toggleSegmentSelection = (segmentId: string) => {
    setSelectedSegmentIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(segmentId)) {
        newSet.delete(segmentId);
      } else {
        newSet.add(segmentId);
      }
      return newSet;
    });
  };

  // Filter size segments based on selection
  const filteredSizeSegments =
    selectedSegmentIds.size > 0
      ? sizeSegments.filter((seg) => selectedSegmentIds.has(seg.id))
      : sizeSegments;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchAllSizeSegments();
  }, [fetchAllSizeSegments]);

  const runCalculations = useCallback(() => {
    const newBreakdown: CostingBreakdown = {};

    const segmentsToCalculate =
      selectedSegmentIds.size > 0
        ? sizeSegments.filter((seg) => selectedSegmentIds.has(seg.id))
        : sizeSegments;

    if (!segmentsToCalculate || segmentsToCalculate.length === 0) {
      updateCostingBreakdown({});
      return;
    }

    segmentsToCalculate.forEach((segment) => {
      const sizeId = segment.id; // Step 1: Calculate Usage (in meters) for each category

      const fabricComponentsUsage = calculateCategoryTotal(
        fabricUsage.fabricComponents.rows,
        sizeId
      );
      const designWorkUsage = calculateCategoryTotal(
        fabricUsage.designWork.rows,
        sizeId
      );
      const astarUsage = calculateCategoryTotal(fabricUsage.astar.rows, sizeId);
      const dupattaUsage = calculateCategoryTotal(
        fabricUsage.dupatta.rows,
        sizeId
      );
      const additionalComponentUsage = calculateCategoryTotal(
        fabricUsage.additionalComponent.rows,
        sizeId
      );
      const manualEmbroideryUsage = calculateCategoryTotal(
        fabricUsage.manualEmbroidery.rows,
        sizeId
      );

      // Step 2: Calculate Cost for each material (Usage * Rate)
      const fabricComponentsCost = fabricComponentsUsage * fabricPannaRate;
      const designWorkCost = designWorkUsage * fabricPannaRate;
      const astarCost = astarUsage * astarPannaRate;
      const dupattaCost = dupattaUsage * dupattaPannaRate;
      const additionalComponentCost =
        additionalComponentUsage * additionalFabricPannaRate;
      const manualEmbroideryCost = manualEmbroideryUsage * fabricPannaRate; 

      const handWorkTotal = calculateCategoryTotal(
        fabricUsage.handwork.rows,
        sizeId
      );
      const embroideryTotal = calculateCategoryTotal(
        fabricUsage.embroidery.rows,
        sizeId
      );
      const stitchingTotal = calculateCategoryTotal(
        fabricUsage.stitching.rows,
        sizeId
      );
      const accessoriesTotal = calculateCategoryTotal(
        fabricUsage.accessories.rows,
        sizeId
      );
      const rateTableTotal = calculateCategoryTotal(
        fabricUsage.rate.rows,
        sizeId
      );

      // Step 4: Calculate final summary totals
      const totalMaterialCost =
        fabricComponentsCost +
        designWorkCost +
        astarCost +
        dupattaCost +
        additionalComponentCost +
        manualEmbroideryCost;
      const totalDirectRates =
        handWorkTotal +
        embroideryTotal +
        stitchingTotal +
        accessoriesTotal +
        rateTableTotal;
      const finalPrice = totalMaterialCost + totalDirectRates; // Step 5: Store all calculated values in the breakdown object

      newBreakdown[sizeId] = {
        // Usages
        fabricComponentsUsage,
        designWorkUsage,
        astarUsage,
        dupattaUsage,
        additionalComponentUsage,
        manualEmbroideryUsage,
        // Costs
        fabricComponentsCost,
        designWorkCost,
        astarCost,
        dupattaCost,
        additionalComponentCost,
        manualEmbroideryCost,
        // Direct Rates
        handWorkTotal,
        embroideryTotal,
        stitchingTotal,
        accessoriesTotal,
        rateTableTotal,
        // Final Totals
        totalMaterialCost: totalMaterialCost,
        totalDirectRates: totalDirectRates,
        finalPrice,
      };
    });

    updateCostingBreakdown(newBreakdown);
  }, [
    fabricUsage,
    fabricPannaRate,
    astarPannaRate,
    dupattaPannaRate,
    additionalFabricPannaRate,
    sizeSegments,
    selectedSegmentIds,
    updateCostingBreakdown,
  ]);

  useEffect(() => {
    runCalculations();
  }, [runCalculations]);

  useEffect(() => {
    if (sizeSegments.length > 0 && Object.keys(breakdown).length === 0) {
      runCalculations();
    }
  }, [sizeSegments, breakdown, runCalculations]);

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Overall Costing
          </h2>
          <p className="text-gray-500">
            Comprehensive pricing calculation for each size based on fabric usage and rates.
          </p>
        </div>
        {/* Multi-select dropdown for size segments */}
        <div ref={dropdownRef} className="relative">
          <button
            type="button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 shadow-sm"
          >
            <span className="text-sm font-medium text-gray-700">
              {selectedSegmentIds.size === 0
                ? "Select Size Segments"
                : selectedSegmentIds.size === allAvailableSegments.length
                ? "All Segments"
                : `${selectedSegmentIds.size} Selected`}
            </span>
            <ChevronDown
              className={`w-4 h-4 text-gray-500 transition-transform ${
                isDropdownOpen ? "rotate-180" : ""
              }`}
            />
          </button>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-96 overflow-y-auto">
              <div className="p-2">
                <div className="flex items-center justify-between mb-2 px-2 py-1">
                  <span className="text-sm font-semibold text-gray-700">
                    Size Segments
                  </span>
                  {selectedSegmentIds.size > 0 && (
                    <button
                      type="button"
                      onClick={() => setSelectedSegmentIds(new Set())}
                      className="text-xs text-blue-600 hover:text-blue-800"
                    >
                      Clear All
                    </button>
                  )}
                </div>
                {allAvailableSegments.map((segment) => {
                  const isSelected = selectedSegmentIds.has(segment.id);
                  return (
                    <label
                      key={segment.id}
                      className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer rounded"
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleSegmentSelection(segment.id)}
                        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-800">
                        {segment.name}
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
           
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
        <label className="text-sm font-medium text-gray-700">Fabric Rate</label>
      <p className="text-xl font-bold text-blue-800">₹{fabricPannaRate.toFixed(2)}</p>
          {fabricPannaRate <= 0 && (
            <p className="text-red-500 text-xs mt-1">• Please add panna rate</p>
          )}
          </div>
          <div className="bg-purple-50 border border-purple-200 p-4 rounded-lg">
            <label className="text-sm font-medium text-gray-700">Astar Rate</label>
          <p className="text-xl font-bold text-purple-800">₹{astarPannaRate.toFixed(2)}</p>
          {astarPannaRate <= 0 && (
            <p className="text-red-500 text-xs mt-1">• Please add panna rate</p>
          )}
        </div>
        <div className="bg-pink-50 border border-pink-200 p-4 rounded-lg">
          <label className="text-sm font-medium text-gray-700">Dupatta Rate</label>
        <p className="text-xl font-bold text-pink-800">₹{dupattaPannaRate.toFixed(2)}</p>
          {dupattaPannaRate <= 0 && (
            <p className="text-red-500 text-xs mt-1">• Please add panna rate</p>
          )}
     </div>
      <div className="bg-gray-50 border border-gray-200 p-4 rounded-lg">
        <label className="text-sm font-medium text-gray-700">Add. Fabric Rate</label>
      <p className="text-xl font-bold text-gray-800">₹{additionalFabricPannaRate.toFixed(2)}</p>
          {additionalFabricPannaRate <= 0 && (
            <p className="text-red-500 text-sm mt-1">• Please add panna rate</p>
          )}
    </div>
     </div>
        
      <div className="bg-white rounded-lg shadow-sm border border-gray-400 overflow-x-auto">
              
        <h3 className="text-xl font-bold text-gray-800 px-6 py-4">
          Cost Breakdown by Size
        </h3>
              
        <table className="w-full  text-[15px]">
                  
          <thead className="bg-gray-50">
                     
            <tr>
                           
              <th className="p-3 text-left border">
                Cost Component (Usage / Cost)
              </th>
                           
              {filteredSizeSegments.map((s) => (
                <th key={s.id} className="p-3 text-center border">
                  {s.name}
                </th>
              ))}
                    
            </tr>
                     
          </thead>

                  
          <tbody>
            <tr className="bg-gray-100 font-semibold text-gray-600">
              <td
                colSpan={filteredSizeSegments.length + 1}
                className="p-2 border text-left"
              >
                MATERIAL COSTS
              </td>
            </tr>
            <tr>
              <td className="p-3 border font-medium">Fabric </td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border ">
                  {breakdown[s.id]?.fabricComponentsUsage?.toFixed(2) ?? "0.00"} m
                  <span className="text-gray-400 mx-1">/</span>
                  <span className="font-semibold text-blue-700">
                    ₹
                    {breakdown[s.id]?.fabricComponentsCost?.toFixed(2) ??
                      "0.00"}
                  </span>
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border font-medium">Job Work</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border ">
                  {breakdown[s.id]?.designWorkUsage?.toFixed(2) ?? "0.00"} m
                  <span className="text-gray-400 mx-1">/</span>
                  <span className="font-semibold  text-blue-700">
                    ₹{breakdown[s.id]?.designWorkCost?.toFixed(2) ?? "0.00"}
                  </span>
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border font-medium">Astar</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border ">
                  {breakdown[s.id]?.astarUsage?.toFixed(2) ?? "0.00"} m
                  <span className="text-gray-400 mx-1">/</span>
                  <span className="font-semibold text-blue-700">
                    ₹{breakdown[s.id]?.astarCost?.toFixed(2) ?? "0.00"}
                  </span>
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border font-medium">Dupatta</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border ">
                  {breakdown[s.id]?.dupattaUsage?.toFixed(2) ?? "0.00"} m
                  <span className="text-gray-400 mx-1">/</span>
                  <span className="font-semibold text-blue-700">
                    ₹{breakdown[s.id]?.dupattaCost?.toFixed(2) ?? "0.00"}
                  </span>
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border font-medium">Additional Component</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border ">
                  {breakdown[s.id]?.additionalComponentUsage?.toFixed(2) ??
                    "0.00"} m
                  <span className="text-gray-400 mx-1">/</span>
                  <span className="font-semibold text-blue-700">
                    ₹
                    {breakdown[s.id]?.additionalComponentCost?.toFixed(2) ??
                      "0.00"}
                  </span>
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border font-medium">Manual Embroidery</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border ">
                  {breakdown[s.id]?.manualEmbroideryUsage?.toFixed(2) ?? "0.00"} m
                  <span className="text-gray-400 mx-1">/</span>
                  <span className="font-semibold text-blue-700">
                    ₹
                    {breakdown[s.id]?.manualEmbroideryCost?.toFixed(2) ?? "0.00"}
                  </span>
                </td>
              ))}
            </tr>
            {/* Direct Rates Section */}
            <tr className="bg-gray-100 font-semibold text-gray-600">
              <td
                colSpan={filteredSizeSegments.length + 1}
                className="p-2 border text-left"
              >
                DIRECT RATES & CHARGES
              </td>
            </tr>
            <tr>
              <td className="p-3 border">Handwork Total</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border font-medium">
                  ₹{breakdown[s.id]?.handWorkTotal?.toFixed(2) ?? "0.00"}
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border">Embroidery Total</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border font-medium">
                  ₹{breakdown[s.id]?.embroideryTotal?.toFixed(2) ?? "0.00"}
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border">Stitching Total</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border font-medium">
                  ₹{breakdown[s.id]?.stitchingTotal?.toFixed(2) ?? "0.00"}
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border">Accessories Total</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border font-medium">
                  ₹{breakdown[s.id]?.accessoriesTotal?.toFixed(2) ?? "0.00"}
                </td>
              ))}
            </tr>
            <tr>
              <td className="p-3 border">Rate Table Total</td>
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border font-medium">
                  ₹{breakdown[s.id]?.rateTableTotal?.toFixed(2) ?? "0.00"}
                </td>
              ))}
            </tr>
            {/* Summary Section */}           {" "}
            <tr className="bg-green-50 font-semibold text-green-800">
                            <td className="p-3 border">Total Material Cost</td> 
                         {" "}
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border">
                  ₹{breakdown[s.id]?.totalMaterialCost?.toFixed(2) ?? "0.00"}
                </td>
              ))}
                         {" "}
            </tr>
                       {" "}
            <tr className="bg-yellow-50 font-semibold text-yellow-800">
                            <td className="p-3 border">Total Direct Rates</td> 
                         {" "}
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border">
                  ₹{breakdown[s.id]?.totalDirectRates?.toFixed(2) ?? "0.00"}
                </td>
              ))}
                         {" "}
            </tr>
                     {" "}
          </tbody>
                   {" "}
          <tfoot>
                       {" "}
            <tr className="bg-orange-100 font-bold text-orange-800">
                           {" "}
              <td className="p-3 border">Final Pricing per Size</td>           
               {" "}
              {filteredSizeSegments.map((s) => (
                <td key={s.id} className="p-3 text-right border text-lg">
                  ₹{breakdown[s.id]?.finalPrice?.toFixed(2) ?? "0.00"}
                </td>
              ))}
                         {" "}
            </tr>
                     {" "}
          </tfoot>
                 {" "}
        </table>
             {" "}
      </div>
           {" "}
      <div>
               {" "}
        <label
          htmlFor="costingNotes"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
                    Costing Notes & Remarks        {" "}
        </label>
               {" "}
        <textarea
          id="costingNotes"
          rows={4}
          value={costingNotes}
          onChange={(e) => updateOverallCostingNotes(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          placeholder="Add any additional notes about pricing, discounts, or special considerations..."
        />
             {" "}
      </div>
         {" "}
    </div>
  );
};

export default OverallCostingTab;
